export const NAME = 'plan';

export const types = {
  PLAN_REQUEST: 'plan/PLAN_REQUEST',
  PLAN_SUCCESS: 'plan/PLAN_SUCCESS',
  PLAN_FAILURE: 'plan/PLAN_FAILURE',
  PLAN_INVALIDATE: 'plan/INVALIDATE',
};
